import { Component, Inject, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { INativePreferences, NATIVE_PREFERENCE_TOKEN } from '@services/index';
import { MyEquipmentService } from '@techwan/ionic-core';

@Component({
  selector: 'app-info-view',
  templateUrl: './app-info-view.component.html',
  styleUrls: ['./app-info-view.component.scss']
})
export class AppInfoViewComponent implements OnInit {
  deviceName: string;
  phoneNumber: string;
  appVersion: string;
  appBuildNumber: string;

  constructor(
    private myEquipment: MyEquipmentService,
    private platform: Platform,
    @Inject(NATIVE_PREFERENCE_TOKEN)
    private nativePreferences: INativePreferences
  ) {}

  ngOnInit() {
    this.myEquipment.myDevice
      .subscribe(communicationEquipment => {
        this.deviceName = communicationEquipment.Name;
        this.phoneNumber = communicationEquipment.PhoneNumber;
      })
      .unsubscribe();

    if (this.platform.is('cordova')) {
      this.nativePreferences.getVersion().then(result => (this.appVersion = result.version));
      this.nativePreferences.getBuildNumber().then(result => (this.appBuildNumber = result.buildNumber));
    }
  }
}
